export interface ExpensePolicyRuleClass {
    AccountExpensePolicyRuleId: number
    AccountExpensePolicyId: string
    AccountId: number
    PolicyRuleName: string
    SystemExpenseRuleTypeId: number
    SystemExpenseRuleTypeName: string
    SystemExpenseLimitTypeId: number
    SystemExpenseLimitTypeName: string
    PolicyRuleValue: number
    IsExpenseCategoryId: boolean
    AccountExpenseCategoryOrTypeId: number
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn:  Date | undefined
    ModifiedByEmployeeId: number
    IsDisabled: boolean
    IsDeleted: boolean
    isSelected: number
}

export const expensePolicyRuleInitialsForAdd = {
    AccountExpensePolicyId: "",
    PolicyRuleName: "",
    SystemExpenseRuleTypeId: 0,
    SystemExpenseRuleTypeName: "",
    SystemExpenseLimitTypeId: 0,
    SystemExpenseLimitTypeName: "",
    PolicyRuleValue: 0,
    IsExpenseCategoryId: false,
    AccountExpenseCategoryOrTypeId: 0,
    AccountExpenseId: 0,
    AccountExpenseName: "",
    AccountExpenseTypeId: 0,
    ExpenseType: "",
    IsDisabled: false,
    IsDeleted: false
}

export const expensePolicyRuleInitialsForUpdate = {
    AccountExpensePolicyRuleId: "",
    AccountExpensePolicyId: "",
    PolicyRuleName: "",
    SystemExpenseRuleTypeId: 0,
    SystemExpenseRuleTypeName: "",
    SystemExpenseLimitTypeId: 0,
    SystemExpenseLimitTypeName: "",
    PolicyRuleValue: 0,
    IsExpenseCategoryId: false,
    AccountExpenseCategoryOrTypeId: 0,
    AccountExpenseId: 0,
    AccountExpenseName: "",
    AccountExpenseTypeId: 0,
    ExpenseType: "",
    IsDisabled: false,
    IsDeleted: false
}